export function formatCurrency(x, decimalCount) {
  return decimalCount ?
    Number.parseFloat(x).toFixed(decimalCount).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    :
    `${x}`.replace(/\d(?=(\d{3})+\.)/g, '$&,');
}



// WEBPACK FOOTER //
// ./src/utils/formatCurrency.js